import { Brain, HeartHandshake, Lightbulb, Users, Compass, Sparkles } from "lucide-react";
import { ChecklistStrip } from "../GuideCards";

const competencies = [
    "Self-awareness",
    "Social awareness",
    "Relationship skills",
    "Responsible decision-making",
];

const priorities = [
    "Mental wellness",
    "Inclusion & belonging",
    "Student leadership",
    "Restorative practices",
];

export default function SchoolsSELAlignment() {
    return (
        <section className="relative overflow-hidden bg-[#fff2cf] px-6 py-16 lg:px-8">
            {/* Optional soft classroom / SEL background image placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-15"
                style={{
                    backgroundImage: "url('/assets/schools/sel-alignment-bg.png')",
                }}
            />

            <div className="relative mx-auto max-w-6xl">
                <div className="mb-10 text-center">
                    <div className="mb-4 inline-flex items-center gap-2 border-[3px] border-black bg-[#16bdf4] px-4 py-2 text-sm font-black uppercase text-white shadow-[4px_4px_0_#000]">
                        <Brain size={18} strokeWidth={3} />
                        SEL + Mental Health
                    </div>

                    <h2 className="text-4xl font-black uppercase leading-none md:text-5xl">
                        Aligned with SEL &
                        <span className="block text-[#ff3366] drop-shadow-[3px_3px_0_#000]">
                            Mental Health Goals
                        </span>
                    </h2>
                </div>

                <div className="grid gap-7 lg:grid-cols-2">
                    <ChecklistStrip
                        icon={Lightbulb}
                        title="Supports Core Competencies"
                        items={competencies}
                        color="bg-[#22c55e]"
                    />

                    <ChecklistStrip
                        icon={Sparkles}
                        title="Perfect for Schools Prioritizing:"
                        items={priorities}
                        color="bg-[#ffbc00]"
                    />
                </div>

                <div className="mt-8 grid gap-4 md:grid-cols-4">
                    <MiniSELCard
                        icon={Brain}
                        title="Self-Awareness"
                        color="bg-[#16bdf4]"
                    />
                    <MiniSELCard
                        icon={Users}
                        title="Social Awareness"
                        color="bg-[#ffbc00]"
                    />
                    <MiniSELCard
                        icon={HeartHandshake}
                        title="Relationships"
                        color="bg-[#ff5fa2]"
                    />
                    <MiniSELCard
                        icon={Compass}
                        title="Decision-Making"
                        color="bg-[#22c55e]"
                    />
                </div>
            </div>
        </section>
    );
}

function MiniSELCard({ icon: Icon, title, color }) {
    return (
        <section className="rounded-[18px] border-[3px] border-black bg-white p-4 text-center shadow-[5px_5px_0_#000]">
            <div
                className={`mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full border-[3px] border-black ${color}`}
            >
                <Icon size={24} strokeWidth={3} />
            </div>

            <h3 className="text-sm font-black uppercase leading-tight">
                {title}
            </h3>
        </section>
    );
}